import React from 'react';
import { RankInsigniaVertical } from './RankInsigniaVertical';
import { getRankKey } from './devPvpLadderMock';
import './battlePlayerRankCorner.css';

/**
 * @param {number|null|undefined} playerRank - Honor / MMR leaderboard position (#n)
 * @param {{ pvp_ladder_rank_index?: number, pvp_in_league?: boolean }|null|undefined} playerPvpLadderRow - from /api/player-ranks
 */
export function resolveBattleRankCornerDisplay(playerRank, playerPvpLadderRow) {
  const rankNum = playerRank != null && playerRank !== undefined ? Number(playerRank) : null;
  const ladderRankIdx =
    playerPvpLadderRow != null && playerPvpLadderRow.pvp_ladder_rank_index != null
      ? Number(playerPvpLadderRow.pvp_ladder_rank_index)
      : null;
  const inLeague = playerPvpLadderRow?.pvp_in_league === true;

  const showMmrLeaderboardNumber =
    rankNum != null &&
    Number.isFinite(rankNum) &&
    (playerPvpLadderRow == null || inLeague === true || ladderRankIdx === 9);

  let ladderRankKey = null;
  if (
    playerPvpLadderRow != null &&
    ladderRankIdx != null &&
    Number.isFinite(ladderRankIdx) &&
    inLeague !== true &&
    ladderRankIdx !== 9
  ) {
    try {
      ladderRankKey = getRankKey(ladderRankIdx);
    } catch {
      ladderRankKey = null;
    }
  }

  return { showMmrLeaderboardNumber, ladderRankKey, rankNum };
}

/**
 * Player avatar corner: PvP ladder insignia before General; after reaching General (league), same # as before.
 * @param {boolean} [compact] - Smaller badge (opponent avatar scale)
 */
export function BattlePlayerRankCorner({ playerRank, playerPvpLadderRow, getRankStyle, compact = false }) {
  const { showMmrLeaderboardNumber, ladderRankKey, rankNum } = resolveBattleRankCornerDisplay(
    playerRank,
    playerPvpLadderRow
  );

  const rootClass =
    'battle-player-rank-corner' + (compact ? ' battle-player-rank-corner--compact' : '');

  if (ladderRankKey) {
    return (
      <div
        className={`${rootClass} battle-player-rank-corner--insignia battle-player-rank-corner--rank-${ladderRankKey}`}
        aria-hidden
      >
        <div className="battle-player-rank-corner__insignia-scale">
          <RankInsigniaVertical rankKey={ladderRankKey} />
        </div>
      </div>
    );
  }

  if (showMmrLeaderboardNumber && rankNum != null) {
    return (
      <div className={`${rootClass} battle-player-rank-corner--number`} style={getRankStyle(rankNum)}>
        #{rankNum}
      </div>
    );
  }

  return null;
}
